import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

export const updateCPTtables = async (payload: any) => {
  try {
    const token = await getBearerToken();
    const response = await fetch(API_ENDPOINTS.UPDATE_J_CODES, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        `Request failed with status ${response.status}: ${errorData.message || response.statusText}`,
      );
    }
    return await response.json();
  } catch (error) {
    console.error("Failed to update CPT tables:", error);
    throw error;
  }
};
